// extracted by mini-css-extract-plugin
module.exports = {"box":"_1BjLR","desc":"_1BCM-"};